import React from "react";
import Select from "react-select";
import ic_filter from "./../../../assets/ic_filter.svg";
import ic_360degree_view from "./../../../assets/ic_360degree_view.svg";
import select_arrow_down from "./../../../assets/select_arrow_down.svg";
import Checkbox from "../../../common/Checkbox/Checkbox";
import {useEffect,useRef } from "react";
import ReactDatePicker from "react-datepicker";
import { Button } from "../../../common/Button/Button";
import ColumnSectionDropdown from "../Admin/ColumnSelectionDropdown";


export default function FacilitatorFollowupFilter(props)
{
    return (
        <>
            <div className="col-12 lpm-filter-section conv-pl40 conv-pr40">
                <div className="row conv-mt20">
                     
                    <div className="col-4">
                    <button 
                            className="lpmss-conss-btnss-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                            onClick={props.onSearchClickedd}>
							Search
					</button>
						<input
							type="text"
							className="conv-float-right form-control conv-h250rem searchss-inputs"
							placeholder="Search....."
							onChange={props.onSearchInputChange}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									props.onSearchClickedd();
								}
							}}
							//autoComplete={false}
							value={props.searchTerm}
							name="searchTerm"
						/>
                        <div className="btn-search-by conv-float-right con-cursor-pointer"
                            onClick={()=>{
                                props.toggleSearchByVisibility();
                            }}
                        >
                            <span className="span-text-search-by">
                                Search By
                            </span>
                            <img
                                alt=""
                                src={select_arrow_down}
                                height={"12px"}
                                width={"12px"}
                                className="conv-ml10"
                            /> 
                            </div>
                            {
                            props.isSearchByDropdownOpen &&
                            <div className="spm-searchs-by" ref={props.SearchDropdownRef}>
                                <ColumnSectionDropdown
                                    isOpen={props.isSearchByDropdownOpen}
                                    toggleSelection={props.selectSearchBySelection}
                                    checkboxItemsList={props.SearchByDropdownList}								
                                />
                            </div>
					    }	
                    </div>


                    <div className="col-8">
                    <div className="row">
                    <div className="col-4 spled-container">
                        <Select 
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: provided => ({ ...provided, zIndex: 3 })
                        }}
                        placeholder="Follow up on"
                        options={props.dateRangeOption}
                        onChange={(value) => props.onDateFilterChange(value) }
                        value={props.dateFilter }
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                            ...theme.colors,
                            primary: '#76287C',
                            primary25: '#F4DFF4',
                            },
                        })}
                        >
                        </Select>
                    </div>

                    <div className="col-4 spled-container conv-zindex">
                       <div className="width-100">                                       
                            <ReactDatePicker 
                                dateFormat="dd/MM/yyyy"
                                selected={props.fromDate}  
                                onChange={(date) =>
                                    
                                    props.onDateRangeChange("fromDate", date)
                                }
								//minDate={new Date()}
                                placeholderText="Follow Up From"   
								 
                            />
                        </div>
                    </div>


                    <div className="col-4 spled-container conv-zindex">
                        <div className="width-100">
                                    <ReactDatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={props.toDate}
                                        onChange={(date) => props.onDateRangeChange("toDate", date)}
                                        placeholderText="Follow Up To"
                                    />
                        </div>
                    </div>
                    </div>
                    </div>
                </div>

            </div>

                <div className="col-12 lpm-filter-section conv-pl40 conv-pr40">
                    <div className="row conv-mt20 conv-pl20">
                        <div className="col-12">
                        <div className="lpm-checkbox-label conv-pr5 conv-mr15  conv-align-self-center conv-float-left">
                                <Checkbox
                                    id={`checkbox-handled`}
                                    checked={props.showIncompleteActions}
                                    onChange={props.toggleShowIncompleteActions}
                                    label={"Show Incomplete only"}																	
                                ></Checkbox>
                        </div>

                        <div className={` conv-align-self-center con-cursor-pointer conv-float-left`}>
                                 
                                <a href="/home/my-resource-assignment/" target="_blank" className="label-link">
                                Manage Services       
                                </a>              
                        </div>

                            <button 
								type="button" 
								className="lpm-con-btn-bordered-filter conv-float-right conv-pr25 conv-pl25" 
								onClick={props.onSearchClicked}>
								Reload
							</button>  
                        </div>
                    </div>                    
                </div>  
        </>
    )
}